import { motion } from 'framer-motion';
import './RehabXF.css';

export default function RehabXF() {
  const tarifas = [
    {
      key: 'gold',
      titleHtml: 'Tarifa <span class="accent">Gold</span>',
      price: '360€',
      desc: 'pensada para personas con una dedicación absoluta a su recuperación.',
      features: [
        { name: 'Número de sesiones a la semana', value: '5' },
        { name: 'Máximo número de personas',      value: '3' },
        { name: 'Valoraciones funcionales',       toggled: true },
        { name: 'Sesiones de readaptación',       toggled: true },
        { name: 'Planificación online (App Móvil)', toggled: true },
        { name: 'Uso libre y preferente de instalaciones', toggled: true },
        { name: 'Cesión de maquinaria',            toggled: true }
      ]
    },
    {
      key: 'silver',
      titleHtml: 'Tarifa <span class="accent">Silver</span>',
      price: '275€',
      desc: 'para personas activas y disponibles para una rehabilitación intensiva.',
      features: [
        { name: 'Número de sesiones a la semana', value: '3' },
        { name: 'Máximo número de personas',      value: '3' },
        { name: 'Valoraciones funcionales',       toggled: true },
        { name: 'Sesiones de readaptación',       toggled: true },
        { name: 'Planificación online (App Móvil)', toggled: true },
        { name: 'Uso libre y preferente de instalaciones', toggled: true },
        { name: 'Cesión de maquinaria',            toggled: true }
      ]
    },
    {
      key: 'bronze',
      titleHtml: 'Tarifa <span class="accent">Bronze</span>',
      price: '205€',
      desc: 'para personas que requieren una opción presencial pero menos intensa.',
      features: [
        { name: 'Número de sesiones a la semana', value: '2' },
        { name: 'Máximo número de personas',      value: '3' },
        { name: 'Valoraciones funcionales',       toggled: true },
        { name: 'Sesiones de readaptación (50€ la sesión)', toggled: false },
        { name: 'Planificación online (App Móvil)', toggled: true },
        { name: 'Uso libre y preferente de instalaciones', toggled: false },
        { name: 'Cesión de maquinaria (Opción de alquiler)', toggled: false }
      ]
    },
    {
      key: 'bono',
      titleHtml: 'Bono <span class="accent">1+1</span>',
      price: '85€',
      desc: 'para personas que sólo necesitan un control y seguimiento de su proceso mediante revisiones y prescripción de planes domiciliarios.',
      features: [
        { name: 'Incluye sesión de fisioterapia (tratamiento y valoración) y prescripción domiciliaria', value: '' },
        { name: 'Sesiones de readaptación (50€ la sesión)',       toggled: false },
        { name: 'Planificación online (App Móvil)', toggled: true },
        { name: 'Uso libre y preferente de instalaciones', toggled: false },
        { name: 'Cesión de maquinaria',            toggled: false }
      ]
    }
  ];

  return (
    <div className="rehab-container">
      <motion.h1
        className="rehab-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        REHABILITACIÓN DE LESIONES
      </motion.h1>

      <motion.div
        className="rehab-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        <h2>Descripción:</h2>
        <p>Para personas en procesos de rehabilitación de lesiones, en un entorno seguro.</p>
      </motion.div>

      <motion.div
        className="rehab-precios"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.8 }}
      >
        {tarifas.map(plan => (
          <div key={plan.key} className={`rehab-precio-cell ${plan.key}`}>
            {/* Mismo orden para todas las tarifas */}
            <h3
              className="rehab-precio-title"
              dangerouslySetInnerHTML={{ __html: plan.titleHtml }}
            />
            <div className="rehab-price-pill">{plan.price}</div>

            <p className="rehab-desc">{plan.desc}</p>
            <div className="stripe" />

            <ul className="rehab-features">
              {plan.features.map((f, i) => (
                <li key={i}>
                  <span>{f.name}</span>
                  {f.toggled !== undefined && (
                    <label className="switch">
                      <input type="checkbox" checked={f.toggled} disabled />
                      <span className="slider"></span>
                    </label>
                  )}
                  {f.value && <span className="feature-value">{f.value}</span>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </motion.div>

      <motion.div
        className="rehab-disclaimer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7, duration: 0.8 }}
      >
        <h2>Algunas observaciones</h2>
        <p>
          – Las tarifas Gold, Silver y Bronze son cuotas mensuales. En caso de finalizar a mitad del ciclo mensual, se facturará prorrateando los días que se hayan utilizado.
        </p>
        <p>
          – La disponibilidad de aforo para el uso libre de instalaciones se determinará reservando previamente de manera online.  
          La preferencia de uso en el espacio se determinará por la tarifa contratada.
        </p>
        <p>
          – A lo largo de un proceso rehabilitador se puede modificar la tarifa en función de las necesidades y la disponibilidad.  
          También se adaptará a periodos vacacionales o parones del tratamiento por cualquier motivo.
        </p>
        <p>
          – Las planificaciones online se determinan bajo petición del paciente en aquellos días concretos que las requiera para trabajar por su cuenta.
        </p>
      </motion.div>
    </div>
  );
}
